/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Dry_RunInputs */

const cs_sreality_dry_run = /** @type {(inputs: Sreality_Dry_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dry run (nevolat Sreality)`)
};

const en_sreality_dry_run = /** @type {(inputs: Sreality_Dry_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dry run (do not call Sreality)`)
};

/**
* | output |
* | --- |
* | "Dry run (do not call Sreality)" |
*
* @param {Sreality_Dry_RunInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_dry_run = /** @type {((inputs?: Sreality_Dry_RunInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Dry_RunInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_dry_run(inputs)
	return cs_sreality_dry_run(inputs)
});